<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
    >
        <path
            d="M6 1C6.55228 1 7 1.44772 7 2V3.25H13V2C13 1.44772 13.4477 1 14 1C14.5523 1 15 1.44772 15 2V3.3848C16.5856 3.82241 17.75 5.27519 17.75 7C17.75 7.41421 17.4142 7.75 17 7.75V8H3.75V13C3.75 14.2427 4.75731 15.25 6 15.25H6.8552C7.26941 15.25 7.6052 15.5858 7.6052 16C7.6052 16.4142 7.26941 16.75 6.8552 16.75H6C3.92889 16.75 2.25 15.0711 2.25 13V7C2.25 5.27519 3.41438 3.82241 5 3.3848V2C5 1.44772 5.44772 1 6 1Z"
            fill="currentColor"
        />
        <path
            d="M17.588 11.4655C17.8451 11.1408 17.7903 10.6691 17.4655 10.412C17.1408 10.1549 16.6691 10.2097 16.412 10.5345L12.2133 15.8381L10.5575 13.9983C10.2804 13.6904 9.80616 13.6654 9.49828 13.9425C9.19039 14.2196 9.16544 14.6938 9.44253 15.0017L11.6925 17.5017C11.8403 17.6659 12.0529 17.7566 12.2737 17.7496C12.4945 17.7426 12.7009 17.6387 12.838 17.4655L17.588 11.4655Z"
            fill="currentColor"
        />
    </svg>
</template>
